import React from 'react';

import './styles.css';

import { LabelForm } from '../LabelForm';
import { InputText } from '../InputText';
import { CheckBox } from '../CheckBox';

export const Cadastro = () => {
  // const { user } = useContext(GlobalContext);
  // const isCadastro = user.id > 0;
  // const [form, setForm] = useState({
  //   nome: '',
  //   email: '',
  // });

  const handleTelefoneChange = (e) => {
    if (e.target.textLength == 2) {
      e.target.value = e.target.value += ' ';
    }
  };

  return (
    <div className={'modal-content-dialog'}>
      <form>
        <div className={'form-group'}>
          <LabelForm text={'Nome'} labelFor={'nome'} />
          <InputText type={'text'} placeHolder={''} className={'form-control'} name={'nome'} onChange="" />
          <i className="material-icons">spellcheck</i>
        </div>
        <div className={'form-group'}>
          <LabelForm text={'E-mail'} labelFor={'email'} />
          <InputText type={'text'} placeHolder={''} className={'form-control'} name={'email'} />
          <i className="material-icons">mail_outline</i>
        </div>
        <div className={'form-group'}>
          <LabelForm text={'Senha'} labelFor={'senha'} />
          <InputText type={'password'} placeHolder={''} className={'form-control'} name={'senha'} />
          <i className="material-icons">lock_outline</i>
        </div>
        <div className={'form-group'} onInput={(e) => handleTelefoneChange(e)}>
          <LabelForm text={'Telefone'} labelFor={'telefone'} />
          <InputText type={'text'} placeHolder={''} className={'form-control'} name={'telefone'} />
          <i className="material-icons">local_phone</i>
        </div>
        <CheckBox text={'Aceito os termos'} name="termoAceite" />
        <div className={'link-termos'}>
          <a
            href={'https://gwsis.com.br/mobile/gerenciador/pedido/GwMobilePhp/termos/termos.php'}
            target={'_blank'}
            rel="noreferrer"
          >
            Ler os termos
          </a>
        </div>
      </form>
      <div className={'clearfix-checkbox'}></div>
    </div>
  );
};
